/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {UpdateMultipleBalancesRequest} from '@cash-web/protos/squareup/banklin/ledger_service.pb'
import {UpdateMultipleBalancesResponse} from '@cash-web/protos/squareup/banklin/ledger_service.pb'


export const updateMultipleBalances = (request: UpdateMultipleBalancesRequest, options?: CashRequestOptions) => post<UpdateMultipleBalancesRequest, UpdateMultipleBalancesResponse>("/2.0/cash/update-multiple-balances", request, {...options, rejectOnError: true })